import { render, staticRenderFns } from "./updateMajor.vue?vue&type=template&id=4dfdb249"
import script from "./updateMajor.vue?vue&type=script&lang=js"
export * from "./updateMajor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports